import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=4f736844&"
import script from "./courseList.js?vue&type=script&lang=js&"
export * from "./courseList.js?vue&type=script&lang=js&"
import style0 from "./courseList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports